module.exports = __webpack_public_path__ + "media/images/gifts/books/sug_livros_7-6aa8cf46de60932edb66e6cfdcbd1397.jpg";